// assets
import { DollarOutlined, HistoryOutlined, CreditCardOutlined } from '@ant-design/icons';

// icons
const icons = {
  DollarOutlined,
  HistoryOutlined,
  CreditCardOutlined
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const utilities = {
  id: 'payments',
  title: 'Payments',
  type: 'group',
  children: [
    {
      id: 'make-payment',
      title: 'Make a Payment',
      type: 'item',
      url: '/payments',
      icon: icons.CreditCardOutlined
    },
    {
      id: 'payment-history',
      title: 'Payment History',
      type: 'item',
      url: '/payments/history',
      icon: icons.HistoryOutlined
    }
  ]
};

export default utilities;
